import { render } from "./ImageFile.vue?vue&type=template&id=901843f0"
import script from "./ImageFile.vue?vue&type=script&lang=js"
export * from "./ImageFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__